import React from 'react';

// Botanical sprig recreated from the supplied reference: no center flower,
// and a curved terminal leaf in place of the outer acorn. Veins are transparent.
export const SPRIG_STEMS = ['M27 66 C89 48 169 54 275 92'];
export const SPRIG_LEAF = 'M0 0 C12 -14 35 -15 52 -7 C40 10 13 13 0 0 Z M5 0 C19 -2 31 -4 44 -6 C29 1 15 4 5 0 Z';
export const SPRIG_LEAVES = [[27, 66.0, 145, 0.63], [67, 58.078, -130, 1], [94, 56.318, -99, 0.62], [65, 58.313, 135, 1.1], [153, 60.229, 138, 1.05], [175, 63.912, 116, 0.66], [223, 75.312, -139, 1.18], [222, 75.032, -91, 0.7]];
export default function HeadingVine({ width, height, side }) {
  return <svg width={width} height={height} viewBox="0 0 280 118" preserveAspectRatio="none" overflow="visible" aria-hidden="true">
    <g transform={side === 'right' ? 'translate(280 0) scale(-1 1)' : undefined}>
      {SPRIG_STEMS.map((d,i) => <path key={i} d={d} fill="none" stroke="#000000" strokeWidth="2.2" strokeLinecap="round" />)}
      {SPRIG_LEAVES.map(([x,y,angle,scale],i) => <path key={i} d={SPRIG_LEAF}
        transform={`translate(${x} ${y}) rotate(${angle}) scale(${scale})`} fill="#000000" fillRule="evenodd" />)}
    </g>
  </svg>;
}
